const createAbortError = () => {
  const error = new Error('Delay aborted');
  error.name = 'AbortError';
  return error;
};
const createDelay = willResolve => (ms,
// @ts-ignore
{
  value,
  signal
} = {}) => {
  if (signal && signal.aborted) {
    return Promise.reject(createAbortError());
  }
  let timeoutId;
  let settle;
  let rejectFn;
  const signalListener = () => {
    clearTimeout(timeoutId);
    rejectFn(createAbortError());
  };
  const cleanup = () => {
    if (signal) {
      signal.removeEventListener('abort', signalListener);
    }
  };
  const delayPromise = new Promise((resolve, reject) => {
    settle = () => {
      cleanup();
      if (willResolve) {
        resolve(value);
      } else {
        reject(value);
      }
    };
    rejectFn = reject;
    timeoutId = setTimeout(settle, ms);
  });
  if (signal) {
    signal.addEventListener('abort', signalListener, {
      once: true
    });
  }

  // @ts-ignore
  delayPromise.clear = () => {
    clearTimeout(timeoutId);
    timeoutId = null;
    cleanup();
    settle();
  };
  return delayPromise;
};
const delay = createDelay(true);

export { delay };
